// @flow
import React from 'react';
import HitPlaceholder from '../Hit/HitPlaceholder';
import MetaBar from '../MetaBar/MetaBar';
import {HtmlTitleWithSeoData} from '../HtmlTitle/HtmlTitle';

type Props = {
    numLoadingPlaceHolders: number
};

export default function ResultsLoading(props: Props) {
    const hits = new Array(props.numLoadingPlaceHolders);
    hits.fill(true);

    return (
        <div className="Results">
            <MetaBar />
            <HtmlTitleWithSeoData resultsLoading />
            <div className="ScrollListener ScrollListener--placeholder">
                <div className="HitCollection HitCollection--placeholder">
                    {hits.map((curr, index) => (
                        <div
                            className="Hit media-flex media-flex--left media-flex--xs"
                            data-wdio="hit-placeholder"
                            aria-busy="true"
                            key={index}
                        >
                            <HitPlaceholder />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
